// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3iAS8","location":"Header_location__2O3c3"};